/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_SendingInputs */

const en_contact_form_sending = /** @type {(inputs: Contact_Form_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const lv_contact_form_sending = /** @type {(inputs: Contact_Form_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nosūta…`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Contact_Form_SendingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_sending = /** @type {((inputs?: Contact_Form_SendingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_SendingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_sending(inputs)
	return en_contact_form_sending(inputs)
});